import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/DeliveryOrderReport/ARReportOutstandingDeliveryOrderAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ARReportOutstandingDeliveryOrderActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/DeliveryOrderReport/ARReportOutstandingDeliveryOrder")
	}

	render() {
		return (
			<Activity 
				name="ARReportOutstandingDeliveryOrder"
				RenderedComponent={this.RenderedComponent}
				context="ARReportOutstandingDeliveryOrder"
				action="ARReportOutstandingDeliveryOrder"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ARReportOutstandingDeliveryOrderActivity)
